import { Fade, Card, Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { useMemo } from "react";
import { getUproColor } from "utils/colors";
import errorIcon from "assets/images/spam_985311.png";
import { appPath } from "services/config";

function ErrorComedor() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const pedidoId = params.get("pedido");

  return (
    <SoftBox
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: getUproColor("uproPink"),
      }}
    >
      <Fade in={true} unmountOnExit>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: "100%",
              borderRadius: "3rem",
              background: "rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              boxShadow: "0 ",
              padding: "3rem",
              margin: "2rem",
            }}
          >
            <SoftBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <SoftBox component="img" src={errorIcon} alt="Error" width="10rem" p={3} />
              <SoftTypography variant="h4" fontWeight="bold" color="white" gutterBottom mt={1}>
                Atención!
              </SoftTypography>
              <SoftTypography variant="h6" color="white" mt={2}>
                El pago para el pedido{pedidoId ? ` #${pedidoId} podría no haberse completado correctamente` : ""}
              </SoftTypography>
              <SoftBox mt={4} display="flex" flexDirection="column" gap={2}>
                <SoftButton
                  color="uproGreen"
                  circular
                  fullWidth
                  onClick={() => (window.location.href = appPath("/sistema-comedor"))}
                >
                  Volver al inicio
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </Card>
        </Grid>
      </Fade>
    </SoftBox>
  );
}

export default ErrorComedor;
